var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from '@emotion/styled';
import { lighten } from 'polished';
import { Input } from './global.styles';
export const FieldContainer = styled.div `
  display: block;
  width: 100%;
  margin: 0.3rem 0;
`;
export const Label = styled.label `
  display: block;
  font-size: 1rem;
  font-weight: 600;
  padding: 0.5rem;
  color: ${(props) => lighten(0.25, props.theme.primaryColour)};
`;
export const InputError = styled.div `
  display: block;
  margin: 0;
  width: 100%;
  color: ${(props) => props.theme.dangerColour};
`;
export const Field = (_a) => {
    var { name, label, fieldError } = _a, rest = __rest(_a, ["name", "label", "fieldError"]);
    return (React.createElement(FieldContainer, null,
        label && React.createElement(Label, { htmlFor: name }, label),
        React.createElement(Input, Object.assign({ id: name, name: name, autoComplete: "off" }, rest)),
        fieldError && React.createElement(InputError, null, fieldError)));
};
//# sourceMappingURL=field.js.map